import { render, staticRenderFns } from "./page-select-motail.vue?vue&type=template&id=27b50d53&scoped=true"
import script from "./page-select-motail.vue?vue&type=script&lang=ts"
export * from "./page-select-motail.vue?vue&type=script&lang=ts"
import style0 from "./page-select-motail.vue?vue&type=style&index=0&id=27b50d53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b50d53",
  null
  
)

export default component.exports